/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChargeDescriptionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ChargeDescriptionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ChargeDescriptionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ChargeDescriptionWidgetConfiguration>): ChargeDescriptionWidgetConfiguration {
        let obj = Object.assign(new ChargeDescriptionWidgetConfiguration(), model);
        ChargeDescriptionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChargeDescriptionWidgetConfiguration>): ChargeDescriptionWidgetConfiguration {
        if (!model) return null;
        return ChargeDescriptionWidgetConfiguration.newInstance(<ChargeDescriptionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChargeDescriptionWidgetConfiguration) {
        if (!obj) return;

        models.ChargeDescriptionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChargeDescriptionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ChargeDescriptionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.group_by_details) {
            models.BillingGroupByDetails.fixupPrototype(this.group_by_details);
        }
    }

    group_by_details: models.BillingGroupByDetails;

}
